module.exports = "/images/london-11.jpg";